function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/toolbar/balloon/balloontoolbar
 */
import { Plugin } from 'ckeditor5/src/core';
import ContextualBalloon from '../../panel/balloon/contextualballoon';
import ToolbarView from '../toolbarview';
import BalloonPanelView from '../../panel/balloon/balloonpanelview.js';
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import Rect from '@ckeditor/ckeditor5-utils/src/dom/rect';
import normalizeToolbarConfig from '../normalizetoolbarconfig';
import { debounce } from 'lodash-es';
import ResizeObserver from '@ckeditor/ckeditor5-utils/src/dom/resizeobserver';
import toUnit from '@ckeditor/ckeditor5-utils/src/dom/tounit';
var toPx = toUnit('px');
/**
 * The contextual toolbar.
 *
 * It uses the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon plugin}.
 *
 * @extends module:core/plugin~Plugin
 */

var BalloonToolbar = /*#__PURE__*/function (_Plugin) {
  _inherits(BalloonToolbar, _Plugin);

  var _super = _createSuper(BalloonToolbar);

  /**
   * @inheritDoc
   */
  function BalloonToolbar(editor) {
    var _this;

    _classCallCheck(this, BalloonToolbar);

    _this = _super.call(this, editor);
    /**
     * A cached and normalized `config.balloonToolbar` object.
     *
     * @type {module:core/editor/editorconfig~EditorConfig#balloonToolbar}
     * @private
     */

    _this._balloonConfig = normalizeToolbarConfig(editor.config.get('balloonToolbar'));
    /**
     * The toolbar view displayed in the balloon.
     *
     * @type {module:ui/toolbar/toolbarview~ToolbarView}
     */

    _this.toolbarView = _this._createToolbarView();
    /**
     * Tracks the focus of the {@link module:core/editor/editorui~EditorUI#getEditableElement editable element}
     * and the {@link #toolbarView}. When both are blurred then the toolbar should hide.
     *
     * @readonly
     * @type {module:utils:focustracker~FocusTracker}
     */

    _this.focusTracker = new FocusTracker(); // Wait for the EditorUI#init. EditableElement is not available before.

    editor.ui.once('ready', function () {
      _this.focusTracker.add(editor.ui.getEditableElement());

      _this.focusTracker.add(_this.toolbarView.element);
    });
    /**
     * An instance of the resize observer that allows to respond to changes in editable's geometry
     * so the toolbar can stay within its boundaries (and group toolbar items that do not fit).
     *
     * **Note**: Used only when `shouldNotGroupWhenFull` was **not** set in the
     * {@link module:core/editor/editorconfig~EditorConfig#balloonToolbar configuration}.
     *
     * **Note:** Created in {@link #init}.
     *
     * @protected
     * @member {module:utils/dom/resizeobserver~ResizeObserver}
     */

    _this._resizeObserver = null;
    /**
     * The contextual balloon plugin instance.
     *
     * @private
     * @type {module:ui/panel/balloon/contextualballoon~ContextualBalloon}
     */

    _this._balloon = editor.plugins.get(ContextualBalloon);
    /**
     * Fires {@link #event:_selectionChangeDebounced} event using `lodash#debounce`.
     *
     * This function is stored as a plugin property to make possible to cancel
     * trailing debounced invocation on destroy.
     *
     * @private
     * @type {Function}
     */

    _this._fireSelectionChangeDebounced = debounce(function () {
      return _this.fire('_selectionChangeDebounced');
    }, 200); // The appearance of the BalloonToolbar method is event–driven.
    // It is possible to stop the #show event and this prevent the toolbar from showing up.

    _this.decorate('show');

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(BalloonToolbar, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var editor = this.editor;
      var selection = editor.model.document.selection; // Show/hide the toolbar on editable focus/blur.

      this.listenTo(this.focusTracker, 'change:isFocused', function (evt, name, isFocused) {
        var isToolbarVisible = _this2._balloon.visibleView === _this2.toolbarView;

        if (!isFocused && isToolbarVisible) {
          _this2.hide();
        } else if (isFocused) {
          _this2.show();
        }
      }); // Hide the toolbar when the selection is changed by a direct change or has changed to collapsed.

      this.listenTo(selection, 'change:range', function (evt, data) {
        if (data.directChange || selection.isCollapsed) {
          _this2.hide();
        } // Fire internal `_selectionChangeDebounced` event to use it for showing
        // the toolbar after the selection stops changing.


        _this2._fireSelectionChangeDebounced();
      }); // Show the toolbar when the selection stops changing.

      this.listenTo(this, '_selectionChangeDebounced', function () {
        if (_this2.editor.editing.view.document.isFocused) {
          _this2.show();
        }
      });

      if (!this._balloonConfig.shouldNotGroupWhenFull) {
        this.listenTo(editor, 'ready', function () {
          var editableElement = editor.ui.view.editable.element; // Set #toolbarView's max-width on the initialization and update it on the editable resize.

          _this2._resizeObserver = new ResizeObserver(editableElement, function () {
            // The max-width equals 90% of the editable's width for the best user experience.
            // The value keeps the balloon very close to the boundaries of the editable and limits the cases
            // when the balloon juts out from the editable element it belongs to.
            _this2.toolbarView.maxWidth = toPx(new Rect(editableElement).width * .9);
          });
        });
      } // Listen to the toolbar view and whenever it changes its geometry due to some items being
      // grouped or ungrouped, update the position of the balloon because a shorter/longer toolbar
      // means the balloon could be pointing at the wrong place. Once updated, the balloon will point
      // at the right selection in the content again.
      // https://github.com/ckeditor/ckeditor5/issues/6444


      this.listenTo(this.toolbarView, 'groupedItemsUpdate', function () {
        _this2._updatePosition();
      });
    }
    /**
     * Creates toolbar components based on given configuration.
     * This needs to be done when all plugins are ready.
     *
     * @inheritDoc
     */

  }, {
    key: "afterInit",
    value: function afterInit() {
      var factory = this.editor.ui.componentFactory;
      this.toolbarView.fillFromConfig(this._balloonConfig, factory);
    }
    /**
     * Creates the toolbar view instance.
     *
     * @private
     * @returns {module:ui/toolbar/toolbarview~ToolbarView}
     */

  }, {
    key: "_createToolbarView",
    value: function _createToolbarView() {
      var shouldGroupWhenFull = !this._balloonConfig.shouldNotGroupWhenFull;
      var toolbarView = new ToolbarView(this.editor.locale, {
        shouldGroupWhenFull: shouldGroupWhenFull,
        isFloating: true
      });
      toolbarView.render();
      return toolbarView;
    }
    /**
     * Shows the toolbar and attaches it to the selection.
     *
     * Fires {@link #event:show} event which can be stopped to prevent the toolbar from showing up.
     */

  }, {
    key: "show",
    value: function show() {
      var _this3 = this;

      var editor = this.editor;
      var selection = editor.model.document.selection;
      var schema = editor.model.schema; // Do not add the toolbar to the balloon stack twice.

      if (this._balloon.hasView(this.toolbarView)) {
        return;
      } // Do not show the toolbar when the selection is collapsed.


      if (selection.isCollapsed) {
        return;
      } // Do not show the toolbar when there is more than one range in the selection and they fully contain selectable elements.
      // See https://github.com/ckeditor/ckeditor5/issues/6443.


      if (selectionContainsOnlyMultipleSelectables(selection, schema)) {
        return;
      } // Don not show the toolbar when all components inside are disabled
      // see https://github.com/ckeditor/ckeditor5-ui/issues/269.


      if (Array.from(this.toolbarView.items).every(function (item) {
        return item.isEnabled !== undefined && !item.isEnabled;
      })) {
        return;
      } // Update the toolbar position when the editor ui should be refreshed.


      this.listenTo(this.editor.ui, 'update', function () {
        _this3._updatePosition();
      }); // Add the toolbar to the common editor contextual balloon.

      this._balloon.add({
        view: this.toolbarView,
        position: this._getBalloonPositionData(),
        balloonClassName: 'ck-toolbar-container'
      });
    }
    /**
     * Hides the toolbar.
     */

  }, {
    key: "hide",
    value: function hide() {
      if (this._balloon.hasView(this.toolbarView)) {
        this.stopListening(this.editor.ui, 'update');

        this._balloon.remove(this.toolbarView);
      }
    }
    /**
     * Returns positioning options for the {@link #_balloon}. They control the way balloon is attached
     * to the selection.
     *
     * @private
     * @returns {module:utils/dom/position~Options}
     */

  }, {
    key: "_getBalloonPositionData",
    value: function _getBalloonPositionData() {
      var editor = this.editor;
      var view = editor.editing.view;
      var viewDocument = view.document;
      var viewSelection = viewDocument.selection; // Get direction of the selection.

      var isBackward = viewDocument.selection.isBackward;
      return {
        // Because the target for BalloonPanelView is a Rect (not DOMRange), it's geometry will stay fixed
        // as the window scrolls. To let the BalloonPanelView follow such Rect, is must be continuously
        // computed and hence, the target is defined as a function instead of a static value.
        // https://github.com/ckeditor/ckeditor5-ui/issues/195
        target: function target() {
          var range = isBackward ? viewSelection.getFirstRange() : viewSelection.getLastRange();
          var rangeRects = Rect.getDomRangeRects(view.domConverter.viewRangeToDom(range)); // Select the proper range rect depending on the direction of the selection.

          if (isBackward) {
            return rangeRects[0];
          } else {
            // Ditch the zero-width "orphan" rect in the next line for the forward selection if there's
            // another one preceding it. It is not rendered as a selection by the web browser anyway.
            // https://github.com/ckeditor/ckeditor5-ui/issues/308
            if (rangeRects.length > 1 && rangeRects[rangeRects.length - 1].width === 0) {
              rangeRects.pop();
            }

            return rangeRects[rangeRects.length - 1];
          }
        },
        positions: getBalloonPositions(isBackward)
      };
    }
    /**
     * Updates the position of the {@link #_balloon} to make up for changes:
     *
     * * in the geometry of the selection it is attached to (e.g. the selection moved in the viewport or expanded or shrunk),
     * * or the geometry of the balloon toolbar itself (e.g. the toolbar has grouped or ungrouped some items and it is shorter or longer).
     *
     * @private
     */

  }, {
    key: "_updatePosition",
    value: function _updatePosition() {
      this._balloon.updatePosition(this._getBalloonPositionData());
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(BalloonToolbar.prototype), "destroy", this).call(this);

      this.stopListening();

      this._fireSelectionChangeDebounced.cancel();

      this.toolbarView.destroy();
      this.focusTracker.destroy();

      if (this._resizeObserver) {
        this._resizeObserver.destroy();
      }
    }
    /**
     * This event is fired just before the toolbar shows up. Stopping this event will prevent this.
     *
     * @event show
     */

    /**
     * This is internal plugin event which is fired 200 ms after model selection last change.
     * This is to makes easy test debounced action without need to use `setTimeout`.
     *
     * @protected
     * @event _selectionChangeDebounced
     */

  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'BalloonToolbar';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [ContextualBalloon];
    }
  }]);

  return BalloonToolbar;
}(Plugin); // Returns toolbar positions for the given direction of the selection.
//
// @private
// @param {Boolean} isBackward
// @returns {Array.<module:utils/dom/position~Position>}


export { BalloonToolbar as default };

function getBalloonPositions(isBackward) {
  var defaultPositions = BalloonPanelView.defaultPositions;
  return isBackward ? [defaultPositions.northWestArrowSouth, defaultPositions.northWestArrowSouthWest, defaultPositions.northWestArrowSouthEast, defaultPositions.northWestArrowSouthMiddleEast, defaultPositions.northWestArrowSouthMiddleWest, defaultPositions.southWestArrowNorth, defaultPositions.southWestArrowNorthWest, defaultPositions.southWestArrowNorthEast, defaultPositions.southWestArrowNorthMiddleWest, defaultPositions.southWestArrowNorthMiddleEast] : [defaultPositions.southEastArrowNorth, defaultPositions.southEastArrowNorthEast, defaultPositions.southEastArrowNorthWest, defaultPositions.southEastArrowNorthMiddleEast, defaultPositions.southEastArrowNorthMiddleWest, defaultPositions.northEastArrowSouth, defaultPositions.northEastArrowSouthEast, defaultPositions.northEastArrowSouthWest, defaultPositions.northEastArrowSouthMiddleEast, defaultPositions.northEastArrowSouthMiddleWest];
} // Returns "true" when the selection has multiple ranges and each range contains a selectable element
// and nothing else.
//
// @private
// @param {module:engine/model/selection~Selection} selection
// @param {module:engine/model/schema~Schema} schema
// @returns {Boolean}


function selectionContainsOnlyMultipleSelectables(selection, schema) {
  // It doesn't contain multiple objects if there is only one range.
  if (selection.rangeCount === 1) {
    return false;
  }

  return _toConsumableArray(selection.getRanges()).every(function (range) {
    var element = range.getContainedElement();
    return element && schema.isSelectable(element);
  });
}
/**
 * Contextual toolbar configuration. Used by the {@link module:ui/toolbar/balloon/balloontoolbar~BalloonToolbar}
 * feature.
 *
 * ## Configuring toolbar items
 *
 *		const config = {
 *			balloonToolbar: [ 'bold', 'italic', 'undo', 'redo' ]
 *		};
 *
 * You can also use `'|'` to create a separator between groups of items:
 *
 *		const config = {
 *			balloonToolbar: [ 'bold', 'italic', | 'undo', 'redo' ]
 *		};
 *
 * Read also about configuring the main editor toolbar in {@link module:core/editor/editorconfig~EditorConfig#toolbar}.
 *
 * ## Configuring items grouping
 *
 * You can prevent automatic items grouping by setting the `shouldNotGroupWhenFull` option:
 *
 *		const config = {
 *			balloonToolbar: {
 *				items: [ 'bold', 'italic', 'undo', 'redo' ],
 *				shouldNotGroupWhenFull: true
 *			},
 *		};
 *
 * @member {Array.<String>|Object} module:core/editor/editorconfig~EditorConfig#balloonToolbar
 */